import { createFileRoute, redirect } from '@tanstack/react-router';
import { PLANNER_VIEWS } from '@/features/planner/components/common/lib/plannerViews';

export const Route = createFileRoute('/(app)/org/$org/loop/$loopId/planner/live/')({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: `/org/$org/loop/$loopId/planner/live/${PLANNER_VIEWS.TABLE}`,
      params,
    });
  },
});
